import rollbar from '~/vendor/rollbar';
import {__DEVELOPMENT__} from '~/utils/env';

function stringifier(k, v) {
  return k === 'history' ? undefined : v;
}

const reportError = function (level, store, action, err) {
  const state = JSON.stringify(store.getState(), stringifier);
  rollbar[level](
    `Error applying action ${action.type}`,
    err || action.payload,
    {action, state}
  );
};

export default function errorReporter(store) {
  return next => action => {
    try {
      if (action.error) {
        reportError('info', store, action);
      }
      return next(action);
    } catch (err) {
      if (__DEVELOPMENT__) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      reportError('critical', store, action, err);
    }
  };
}
